import React, { useState, useRef, useEffect } from "react";

// Per-card folder organizer: a folder icon that opens a popover listing all
// folders with checkboxes. Toggling adds/removes the template from a folder.
export default function TemplateFolderMenu({ folders, activeFolderKeys, onToggle }) {
	const [open, setOpen] = useState(false);
	const ref = useRef(null);

	useEffect(() => {
		if (!open) return;
		const onClick = (e) => {
			if (ref.current && !ref.current.contains(e.target)) setOpen(false);
		};
		const onKey = (e) => { if (e.key === "Escape") setOpen(false); };
		document.addEventListener("mousedown", onClick);
		document.addEventListener("keydown", onKey);
		return () => {
			document.removeEventListener("mousedown", onClick);
			document.removeEventListener("keydown", onKey);
		};
	}, [open]);

	const count = activeFolderKeys ? activeFolderKeys.size : 0;

	return (
		<div className="tpl-folder-menu" ref={ref}>
			<button
				type="button"
				className={`tpl-folder-menu-btn ${count > 0 ? "has" : ""}`}
				onClick={(e) => { e.stopPropagation(); setOpen((v) => !v); }}
				title="Ranger dans un dossier"
				aria-label="Ranger dans un dossier"
			>
				<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
					<path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z" />
				</svg>
				{count > 0 && <span className="tpl-folder-menu-badge">{count}</span>}
			</button>

			{open && (
				<div className="tpl-folder-menu-pop" onClick={(e) => e.stopPropagation()}>
					<div className="tpl-folder-menu-head">Ranger dans</div>
					{(!folders || folders.length === 0) ? (
						<div className="tpl-folder-menu-empty">Aucun dossier</div>
					) : (
						folders.map((f) => {
							const fKey = f.Key ?? f.key;
							const fName = f.NomDossier ?? f.nomDossier ?? "Dossier";
							const checked = !!activeFolderKeys && activeFolderKeys.has(fKey);
							return (
								<label key={fKey} className="tpl-folder-menu-item">
									<input
										type="checkbox"
										checked={checked}
										onChange={() => onToggle(fKey, !checked)}
									/>
									<span>{fName}</span>
								</label>
							);
						})
					)}
				</div>
			)}
		</div>
	);
}
